import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Form, Input, Button, Row, Col, Breadcrumb } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import 'antd/dist/antd.css';
import { getEcole } from '../ecole/ecole.reducer';
import { createComptable, getComptables, reset, updateComptable } from './comptable-reducer';
export const ComptableUpdate = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const comptable = useAppSelector(state => state.comptable.entity);
  const updateSuccess = useAppSelector(state => state.comptable.updateSuccess);
  const updating = useAppSelector(state => state.comptable.updating);
  const currentEcole = useAppSelector(state => state.ecole.entity);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/comptable/${currentEcole && currentEcole.id}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      dispatch(getEcole(props.match.params.ecoleid));
    } else {
      dispatch(getEcole(props.match.params.ecoleid));
      dispatch(getComptables(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose(event);
    }
  }, [updateSuccess]);

  const saveComptable = values => {
    const entity = {
      ...comptable,
      ...values,
      ecoleId: props.match.params.ecoleid,
    };
    if (isNew) {
      dispatch(createComptable(entity));
    } else {
      dispatch(updateComptable(entity));
    }
  };
  const { match } = props;
  return (
    <div>
      {isNew ? (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/comptable/${currentEcole && currentEcole.id}`}>Comptables</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/comptable/${currentEcole && currentEcole.id}`}>Comptables</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${match.url}`}>Details</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      )}
      <Row className="justify-content-center">
        <Col span={12}>
          {isNew ? (
            <h2 id="korischoolApp.comptable.home.createOrEditLabel" data-cy="comptable">
              <Translate contentKey="korischoolApp.comptable.home.createLabel">Create a Comptable</Translate>
            </h2>
          ) : (
            <h2 id="korischoolApp.comptable.home.createOrEditLabel" data-cy="ComptableUpdateHeading">
              <Translate contentKey="korischoolApp.comptable.home.editLabel">Edit a Comptable</Translate>
            </h2>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col span={18} offset={6}>
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            layout="vertical"
            size="large"
            onFinish={saveComptable}
            initialValues={!isNew && comptable}
          >
            <Form.Item label="Login" name="login" rules={[{ required: true }]}>
              <Input placeholder="login comptable" />
            </Form.Item>
            <Form.Item label="Prénom" name="firstName" rules={[{ required: true }]}>
              <Input placeholder="Prenom" />
            </Form.Item>
            <Form.Item label="Nom" name="lastName" rules={[{ required: true }]}>
              <Input placeholder="Nom" />
            </Form.Item>
            <Form.Item
              label="Téléphone"
              name="telephone"
              rules={[{ required: true, min: 0, max: 9, message: 'ce champs doit contenir au maximum 9 chiffres' }]}
            >
              <Input placeholder="Téléphone" />
            </Form.Item>
            <Form.Item label="E-mail" name="email" rules={[{ required: true, type: 'email', message: 'saisir un e-mail valide' }]}>
              <Input placeholder="E-mail" />
            </Form.Item>
            <Form.Item label="Adresse" name="adresse" rules={[{ required: true }]}>
              <Input.TextArea placeholder="Adresse" />
            </Form.Item>
            <Form.Item>
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                data-cy="entityCreateSaveButton"
                htmlType="submit"
                id="save-entity"
              >
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
export default ComptableUpdate;
